import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useShortRelativeDate } from '~/routes/community/_hooks/useShortRelativeDate';

type EditedIndicatorProps = {
  editedAt: string;
};

export const EditedIndicator: FC<EditedIndicatorProps> = ({ editedAt }) => {
  const { t } = useTranslation();
  const formatRelativeTime = useShortRelativeDate();

  return (
    <span className="text-[13px] leading-4 text-black/50">
      {t('community.edited_time', { time: formatRelativeTime(editedAt, { withAgo: true }) })}
    </span>
  );
};
